import { clone } from '../../helpers/';
import types from '../types';

interface ISidebarState {
    isOpen: boolean;
    componentId: string;
    pinned: boolean;
    previousOutputBlocks: any;
    isLayoutPanel?: boolean;
    layoutPanelIndex?: number;
};

const initialState: ISidebarState = {
    isOpen: false,
    componentId: null,
    pinned: false,
    previousOutputBlocks: null,
    isLayoutPanel: false
};

const sidebarReducer = function (state: ISidebarState = initialState, action) {

    let stateClone: ISidebarState = clone(state);

    switch (action.type) {

        case types.TOGGLE_SIDEBAR:
            stateClone = toggle(stateClone, action.componentId, action.keepOpen, action.previousOutputBlocks, action.isLayoutPanel, action.layoutPanelIndex);
            break;

        case types.TOGGLE_SIDEBAR_PIN:
            stateClone = togglePin(stateClone);
            break;

        default:
            break;

    }

    return stateClone;

};

let toggle = (state: ISidebarState, componentId: string, keepOpen?: boolean, previousOutputBlocks?: any, isLayoutPanel?: boolean, layoutPanelIndex?: number) => {

    if (keepOpen && !state.isOpen)
        return state;
    else if (!keepOpen)
        state.isOpen = !state.isOpen;

    if (isLayoutPanel)
        state.isLayoutPanel = true;
    else
        state.isLayoutPanel = false;


    if (layoutPanelIndex !== null && layoutPanelIndex !== undefined)
        state.layoutPanelIndex = layoutPanelIndex;

    state.previousOutputBlocks = previousOutputBlocks;

    state.componentId = componentId;

    return state;

};

let togglePin = (state: ISidebarState) => {

    state.pinned = !state.pinned;
    return state;

};

export default sidebarReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/sidebar.ts